// ═══════════════════════════════════════════════
//   SCORES — V1 Podium hero leaderboard
// ═══════════════════════════════════════════════

const {S, DB, openWin, earlyBadgeHTML, GAME_REGISTRY} = window;

const GAME_META = Object.fromEntries(
    GAME_REGISTRY
        .filter(g => g.leaderboard)
        .map(g => [g.key, {label: g.name, icon: g.icon}])
);

const LIST_ROWS = 4;
const SCORES_POLL_MS = 30_000;

let scoresCurTab = 'stars';
let scoresCache  = null;
let _scoresTimer = null;

function _stopAutoRefresh() {
    clearInterval(_scoresTimer);
    _scoresTimer = null;
}

function _startAutoRefresh() {
    _stopAutoRefresh();
    _scoresTimer = setInterval(() => {
        const win = document.getElementById('w-scores');
        if (!win || win.style.display === 'none') {
            _stopAutoRefresh();
            return;
        }
        fetchScores();
    }, SCORES_POLL_MS);
}

async function openScores() {
    openWin('w-scores');
    await fetchScores();
    _startAutoRefresh();
}

async function fetchScores() {
    const body = document.getElementById('scores-content');
    if (!DB.available() || !body) return;
    body.className = 'scores-loading';
    body.innerHTML = 'Fetching scores...';
    try {
        const {data, error} = await DB.fetchLeaderboard();
        if (error) throw error;
        scoresCache = data || [];
        renderScores();
    } catch (e) {
        console.warn('Leaderboard fetch failed:', e);
        body.innerHTML = 'Could not load scores 😢<br>Try again later!';
    }
}

function _iconSrc(r) {
    return `assets/profile/profile_icon${r.icon_idx || 1}.png`;
}

function _podiumSlot(r, cls, rankNum, showCrown, myName) {
    if (!r) {
        return `<div class="scores-podium-slot ${cls}">
            <div class="scores-podium-crown-space"></div>
            <div class="scores-podium-avatar"></div>
            <div class="scores-podium-name">—</div>
            <div class="scores-podium-pts">—</div>
            <div class="scores-podium-bar">${rankNum}</div>
        </div>`;
    }
    const isMe = r.player.toUpperCase() === myName;
    return `<div class="scores-podium-slot ${cls}">
        ${showCrown
            ? '<div class="scores-podium-crown">👑</div>'
            : '<div class="scores-podium-crown-space"></div>'}
        <div class="scores-podium-avatar${isMe ? ' me' : ''}">
            <img src="${_iconSrc(r)}" alt="${r.player}">
        </div>
        <div class="scores-podium-name${isMe ? ' me' : ''}">@${r.player}</div>
        <div class="scores-podium-pts">${Number(r.score).toLocaleString()}</div>
        <div class="scores-podium-bar">${rankNum}</div>
    </div>`;
}

// Dense ranking ("1223"): tied scores share a rank, and the next score
// down gets the very next rank — no gaps. e.g. scores [100,100,90,80]
// → ranks [1,1,2,3]. So two players tied for 1st are followed by a 2nd
// place (not a 3rd), which is what feels right on a podium.
function _withRanks(rows) {
    let rank = 0, lastScore = null;
    return rows.map(r => {
        if (r.score !== lastScore) rank += 1;
        lastScore = r.score;
        return {...r, rank};
    });
}

function renderScores() {
    const body = document.getElementById('scores-content');
    if (!body || !scoresCache) return;
    body.className = '';
    const myName = (S.profileData.name || '').toUpperCase();

    const tabHtml = Object.entries(GAME_META).map(([key, g]) => {
        const active = scoresCurTab === key;
        return `<button class="scores-tab${active ? ' on' : ''}" onclick="setScoresTab('${key}')" data-label="${g.label.toUpperCase()}">${g.icon}</button>`;
    }).join('');

    const allRows = _withRanks(
        scoresCache
            .filter(r => r.game_key === scoresCurTab)
            .sort((a, b) => b.score - a.score)
    );

    const cur = GAME_META[scoresCurTab] || {label: scoresCurTab, icon: '★'};

    // Podium: every player at rank ≤ 3 shows up, so a tie at 1st renders
    // multiple gold slots side-by-side. Empty ranks get a "—" placeholder
    // so the silver/gold/bronze layout stays recognisable even when ties
    // collapse a rank (e.g. 1,1,3 has no rank 2).
    const rank1 = allRows.filter(r => r.rank === 1);
    const rank2 = allRows.filter(r => r.rank === 2);
    const rank3 = allRows.filter(r => r.rank === 3);
    const rest  = allRows.filter(r => r.rank > 3).slice(0, LIST_ROWS);

    const _renderGroup = (group, cls, rankNum, showCrown) =>
        group.length
            ? group.map(r => _podiumSlot(r, cls, rankNum, showCrown, myName)).join('')
            : _podiumSlot(null, cls, rankNum, false, myName);

    let podiumHtml = '';
    if (allRows.length > 0) {
        const second = _renderGroup(rank2, 'second', 2, false);
        const first  = _renderGroup(rank1, 'first',  1, true);
        const third  = _renderGroup(rank3, 'third',  3, false);
        podiumHtml = `<div class="scores-podium">
            <span class="scores-podium-spark s1">✦</span>
            <span class="scores-podium-spark s2">✦</span>
            ${second}${first}${third}
        </div>`;
    }

    let listHtml = '';
    if (!allRows.length) {
        listHtml = `<div class="scores-empty">No scores yet — be the first!</div>`;
    } else {
        rest.forEach(r => {
            const isMe = r.player.toUpperCase() === myName;
            listHtml += `<div class="scores-row${isMe ? ' me' : ''}">
                <span class="scores-rank">#${r.rank}</span>
                <div class="scores-avatar"><img src="${_iconSrc(r)}" alt="${r.player}"></div>
                <span class="scores-name">@${r.player}${isMe && S.data_early_adopter_flag ? earlyBadgeHTML(14) : ''}</span>
                <span class="scores-pts">${Number(r.score).toLocaleString()}</span>
            </div>`;
        });
    }

    let youHtml = '';
    const me = allRows.find(r => r.player.toUpperCase() === myName);
    if (me) {
        const onPodium = me.rank <= 3;
        const inRest   = rest.some(r => r.player.toUpperCase() === myName);
        if (!onPodium && !inRest) {
            // First player whose score is strictly greater — i.e. the
            // next rank up, not just the next index (with ties they
            // can be the same).
            const next = allRows.find(r => r.score > me.score);
            const sub = next
                ? `${(next.score - me.score).toLocaleString()} TO NEXT RANK`
                : `★ TOP OF THE BOARD`;
            youHtml += `<div class="scores-you">
                <span class="scores-you-tag">YOU</span>
                <span class="scores-rank">#${me.rank}</span>
                <div class="scores-avatar"><img src="assets/profile/profile_icon${window.profIconIdx || 1}.png" alt="you"></div>
                <div class="scores-you-meta">
                    <span class="scores-you-name">@${me.player}</span>
                    <span class="scores-you-sub">${sub}</span>
                </div>
                <span class="scores-pts">${Number(me.score).toLocaleString()}</span>
            </div>`;
            if (rest.length) {
                listHtml += `<div class="scores-skip">· · ·</div>`;
            }
        }
    }

    const total = allRows.length;

    body.innerHTML = `
        <div class="scores-tabs-wrap"><div class="scores-tabs">${tabHtml}</div></div>
        <div class="scores-main">
            <div class="scores-header">
                <div class="scores-header-left">
                    <div class="scores-game-tile">${cur.icon}</div>
                    <div>
                        <div class="scores-title">${cur.label.toUpperCase()} · TOP 100</div>
                        <div class="scores-period">
                            <span>TODAY</span><span>WEEK</span><span class="on">ALL TIME</span>
                        </div>
                    </div>
                </div>
                <div class="scores-players">● ${total} PLAYER${total !== 1 ? 'S' : ''}</div>
            </div>
            ${podiumHtml}
            <div class="scores-list">${listHtml}${youHtml}</div>
        </div>`;
}

function setScoresTab(key) {
    scoresCurTab = key;
    renderScores();
}

function resetScores() {
    _stopAutoRefresh();
    scoresCache  = null;
    scoresCurTab = 'stars';
}

window.openScores   = openScores;
window.fetchScores  = fetchScores;
window.renderScores = renderScores;
window.setScoresTab = setScoresTab;
window.resetScores  = resetScores;
